module.exports = __webpack_public_path__ + "static/img/unMute_camera.ef15a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/unMute_camera.png
// module id = Letc
// module chunks = 24